import comp from "./EmptyView";
export default comp;
